import React, { useRef } from "react";
import { useEffect, useLayoutEffect, useState } from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import Tile from "@src/stories/components/Tile/Tile";
import { Headings } from "@arctheme-components/elements/Headings/Headings";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";

export default function Grid({
     settings,
     columns,
     headerText,
     subtext,
     tagline,
     columns_count,
}) {
    const { section, mobile_breakpoint } = settings;
    // const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    const isMobile = useMobileBreakpoint("1024px");

    const isFirstColumnDefaultLayout = columns[0]?.settings.layout === "default";
    let firstBlockHeight = isMobile
        ? columns[0]?.settings.mobile_block_height
        : columns[0]?.settings.block_height;

    if (!isFirstColumnDefaultLayout) {
        firstBlockHeight = 0;
    }
    const gapBetweenBlocksX = isMobile
        ? settings.section.gap_mobile
        : settings.section.gap;
    const gapBetweenBlocksY = isMobile
        ? settings.section.gap_y_mobile
        : settings.section.gap_y;

    const columnsCount = isMobile
        ? settings.section.columns_count_mobile
        : settings.section.columns_count;


    const titleStyle = isMobile
        ? settings.section.header_style_mobile
        : settings.section.header_style;

    const taglineStyle = isMobile
        ? settings.section.tagline_style_mobile
        : settings.section.tagline_style;

    const contentStyle = isMobile
        ? settings.section.subtext_style_mobile
        : settings.section.subtext_style;

    const layoutType = isMobile
        ? settings.section.layout_mobile
        : settings.section.layout;

    const gridColumnTiles: any = [];

    columns.map((columnData) => {
        if (!gridColumnTiles[columnData.settings.column]) {
            gridColumnTiles[columnData.settings.column] = [];
        }
        gridColumnTiles[columnData.settings.column].push(columnData);
    });

    return (
        <div className={`multicolumn-${layoutType}`}>
            {(tagline || headerText || subtext) && (
                <div className={`multicolumn-content-top w-full my-[16px]
                    justify-${settings.section.content_alignment_mobile}
                    lg:justify-${settings.section.content_alignment_desktop}
                    text-${settings.section.content_alignment_mobile}
                    lg:text-${settings.section.content_alignment_desktop}
                `}>
                    {tagline && <Paragraph text={tagline} type={taglineStyle}/>}
                    {headerText && <Headings text={headerText} type={`h2`} classes={titleStyle}/>}
                    {subtext && <Paragraph text={subtext} type={contentStyle}/>}
                </div>
            )}

            <div
                className={`${layoutType == 'grid' && `grid`} ${gridColumnTiles.length > 1 && `grid-cols-${columnsCount}`} ${layoutType == 'flex_grid' && `flex`} w-full lg:h-[${firstBlockHeight}px]  ${settings.direction} justify-${settings.section.content_alignment_mobile} lg:justify-${settings.section.content_alignment_desktop}`}
                {...(settings.section.use_carousel &&
                    !isMobile && {
                        "x-data": "carousel()",
                        "x-init": "$nextTick(() => { initialise(false, true, false) })",
                        "x-ref": "carousel",
                    })}
                {...(settings.section.use_carousel &&
                    isMobile && {
                        "x-data": "carousel()",
                        "x-init": "$nextTick(() => { destroy() })",
                        "x-ref": "carousel",
                    })}
            >
                {gridColumnTiles.map((groupedTiles, groupIndex) => {
                    return (
                        <div key={groupIndex} className={`
                            ${(groupedTiles.length > 1 && groupIndex > 1) ?  `flex flex-col` : ``}
                            ${(groupedTiles.length > 1 && groupIndex == 0) ?  `flex flex-row flex-wrap` : ``}
                        `}>
                        {

                        groupedTiles.map((column, index) => {
                            let columnWidth = isMobile
                                ? column.settings.width_mobile
                                : column.settings.width;

                            const defaultFlexBasis = `${100 / columns_count}%`;

                            let flexBasis =
                                columnWidth > 0
                                    ? `calc(${columnWidth}% - ${gapBetweenBlocksX}px)`
                                    : `calc(${defaultFlexBasis} - ${gapBetweenBlocksX}px)`;

                            if (column.settings.main_aspect_ratio) {
                                columnWidth = isMobile
                                    ? column.settings.mobile_block_height
                                    : column.settings.block_height;

                                flexBasis =
                                    columnWidth > 0
                                        ? `calc(${columnWidth}px - ${gapBetweenBlocksX}px)`
                                        : `calc(${defaultFlexBasis} - ${gapBetweenBlocksX}px)`;
                            }

                            const columnHeight = isMobile
                                ? column.settings.mobile_block_height
                                : column.settings.block_height;
                            const heightStyle = columnHeight > 0 ? `${columnHeight}px` : "auto";
                            // console.log(`Group Column - ${groupIndex}`, column);

                            return (
                                <div
                                    key={column.key || index}
                                    style={{
                                        flexBasis,
                                        height: column.settings.layout == "default" && heightStyle,
                                        marginLeft:
                                            !settings.section.use_carousel &&
                                            index % columns_count !== 0 && !column.settings.main_aspect_ratio
                                                ? `${gapBetweenBlocksX / 2}px`
                                                : `${gapBetweenBlocksX / 2}px`,
                                        marginRight:
                                            !settings.section.use_carousel &&
                                            (index + 1) % columns_count !== 0 && !column.settings.main_aspect_ratio
                                                ? `${gapBetweenBlocksX / 2}px`
                                                : `${gapBetweenBlocksX / 2}px`,
                                        marginTop: `${gapBetweenBlocksY / 2}px`,
                                        marginBottom: `${gapBetweenBlocksY / 2}px`,
                                        ...(settings.section.use_carousel && {
                                            marginLeft: `${gapBetweenBlocksX / 2}px`,
                                            marginRight: `${gapBetweenBlocksX / 2}px`,
                                        }),
                                    }}
                                    className="box-border overflow-hidden"
                                >
                                    <Tile
                                        data={column}
                                        layout={column.settings.layout}
                                        height={heightStyle}
                                        settings={settings}
                                    />
                                </div>
                            );
                        })
                    }
                    </div>
                    );
                })}
            </div>
        </div>
    );
}